import {CommandStrategy, SubmenuType} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {CardSelector} from '../../../../../controllers/CardSelector';
import {ApiSendCommandsController} from '../../../../../controllers/ApiSendCommandsController';
import {PlayerData} from '../../../../../data/active_data/field_config/PlayerData';
import {DynamicData} from '../../../../../data/DynamicData';

export class PassStackToPlayerCommandStarategy extends CommandStrategy
{

    private stack: Stack | undefined;

    constructor() {
        super({
            iconId: PieMenuIcons.MOV,
            hint: 'Pass to\nPlayer',
            hasSubmenu: true,
            submenuType: SubmenuType.PLAYER
        });
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        this.stack = stack;
        let filterdPlayers: PlayerData[] = DynamicData.getNotMyActivePlayers();
        return CardSelector.selectedCards.length == 0 && !!stack && stack.activeData.cards.length == 1 && filterdPlayers.length > 0 && DynamicData.settings.canTablePassCards;
    }

    execute(commandIndex: number): void {
        let filterdPlayers: PlayerData[] = DynamicData.getNotMyActivePlayers();
        if (!filterdPlayers.length) {
            return;
        }
        let playerId: string = filterdPlayers[commandIndex].id;
        ApiSendCommandsController.passToPlayer([this.stack!.activeData.cards.getLast().id], playerId);
    }

    getTier2CommandsCount(): number {
        let filterdPlayers: PlayerData[] = DynamicData.getNotMyActivePlayers();
        return filterdPlayers.length;
    }
}
